// libs
import { styled } from '@nykaa/ui-components';

// components
import BaseColorSwatches from 'shared/components/ColorSwatchesPDP';
import TertiaryTitle from 'shared/layouts/DetailsPage/components/ProductInfo/components/TertiaryTitle';

export const Container = styled.div`
  margin-top: ${({ theme }) => theme.spacing.spacing100};
`;

export const SelectedColor = styled.div`
  ${({ theme }) => theme.typography.bodyMedium};
  color: ${({ theme }) => theme.colors.textPrimary};
  margin-bottom: ${({ theme }) => theme.spacing.spacing60};
`;

export const ColorSwatches = styled(BaseColorSwatches)`
  width: 560px;
  max-width: 560px;
  .color-item {
    width: calc(560px * 0.15);
    height: calc(560px * 0.15 * 4 / 3);
  }
`;

export const SecondaryTitle = styled(TertiaryTitle)`
  ${({ theme }) => theme.typography.titleMedium};
`;
